import { Form, Link, usePage } from "@inertiajs/react";
import { ChevronDown, Search, User, Users } from "lucide-react";
import {
  builds,
  comps,
  profileBuilds,
  search,
  userSettings,
  usersSessions,
  usersOmniauthCallbacks,
} from "@/api";
import { SharedProps } from "@/types";
import { useUmami } from "@danielgtmn/umami-react";
import styles from "./NavigationBar.module.css";
import { Avatar, TextField, DropdownMenu, Button, IconButton } from "@/ui";
import { m } from "@/paraglide/messages";

export default function NavigationBar() {
  const { current_user, params } = usePage<SharedProps>().props;
  const { identify } = useUmami();

  if (current_user) {
    identify(`${current_user.id}`, { name: current_user.name });
  }

  return (
    <nav className={styles.nav}>
      <h1>
        <Link href={search.show.path()}>
          <img
            src="/images/logo/SVG/Logo-light.svg"
            alt="Albion.Build Logo"
            height="48px"
            className={styles.desktopLogo}
          />
          <img
            src="/images/logo/SVG/icon-light.svg"
            alt="Albion.Build Logo"
            height="48px"
            className={styles.mobileLogo}
          />
        </Link>
      </h1>

      <Form className={styles.search} action={search.show.path()}>
        <TextField
          name="query"
          placeholder={m["nav.search.placeholder"]()}
          defaultValue={params.query}
          icon={<Search height="16" width="16" />}
        />
      </Form>

      <div className={styles.menu}>
        {current_user ? (
          <>
            <DropdownMenu
              trigger={(props) => (
                <Button variant="primary" {...props}>
                  {m["nav.create"]()}
                </Button>
              )}
            >
              <Button as="link" href={builds.new.path()}>
                <User strokeWidth="1.5" height="16px" />
                {m["nav.build.create"]()}
              </Button>

              <Button as="link" href={comps.new.path()}>
                <Users strokeWidth="1.5" height="16px" />
                {m["nav.comp.create"]()}
              </Button>
            </DropdownMenu>

            <Link
              href={profileBuilds.index.path({
                profile_username: current_user.slug,
              })}
            >
              <Avatar size="s" src={current_user?.image ?? undefined} fallback={<User />} />
            </Link>

            <DropdownMenu
              trigger={(props) => (
                <IconButton {...props}>
                  <ChevronDown width="24px" height="24px" />
                </IconButton>
              )}
            >
              <Button as="link" href={userSettings.show.path()}>
                {m["nav.settings"]()}
              </Button>

              <Button variant="destructive" as="csfr" action={usersSessions.destroy}>
                {m["nav.logout"]()}
              </Button>
            </DropdownMenu>
          </>
        ) : (
          <Button as="csfr" action={usersOmniauthCallbacks.passthru}>
            {m["nav.login"]()}
          </Button>
        )}
      </div>
    </nav>
  );
}
